import { ContentLayout } from "@/components/Layout";
import { Authorization, ROLES } from "@/libs/authorization";
import { ViewPostScreen } from "../components";
import { Header } from "../components/post";
import usePermission from "@/hooks/usePermission";

export const Posts = () => {
  const { showPost } = usePermission();

  return (
    <ContentLayout title="Posts" header={<Header />}>
      <div className="bg-white flex mb-6 rounded-2xl flex-col dark:bg-slate-900/70">
        <div className="flex-1">
          <Authorization
            forbiddenFallback={
              <div>
                You are not allowed to view this. Please contact administrator
              </div>
            }
            allowedRoles={[ROLES.USER]}
            policyCheck={showPost}
          >
            <ViewPostScreen />
          </Authorization>
        </div>
      </div>
    </ContentLayout>
  );
};
